import styled from 'styled-components';

import { ChatSms } from 'components/chat/sms';

export const Container = styled.div`
  flex: 1;
  display: flex;
  overflow-y: auto;
  flex-direction: column;
`;

export const StyledChat = styled(ChatSms)`
  flex: 1;
  min-height: 0;
`;
